import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, reactive } from 'vue'
import { silpoChequesApi } from '@/di/api'
import { notifyInjectionKey } from '@/keys'
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoLoadLastChequesForm',
  setup(__props) {

const notify = inject(notifyInjectionKey)

const data = { selectOptions: { 1: 'Last day', 3: 'Last three days', 7: 'Last week', 30: 'Last month' } }

const model = reactive<{ days: number }>({ days: 3 })
const lock = reactive<{ formSubmitting: boolean }>({ formSubmitting: false })

async function submit (): Promise<void> {
    lock.formSubmitting = true

    try {
        await silpoChequesApi.loadLastCheques(parseInt('' + model.days))
        notify?.({ text: 'Task created' })
    } finally {
        lock.formSubmitting = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Load last cheques for interval")
      ]),
      _: 1
    }),
    _createVNode(_component_FormKit, {
      modelValue: model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model) = $event)),
      type: "form",
      actions: false,
      "form-class": "row row-cols-lg-auto g-3 align-items-center",
      onSubmit: submit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "select",
          name: "days",
          "input-class": "form-days-select",
          options: data.selectOptions
        }, null, 8, ["options"]),
        _createVNode(_component_FormKit, {
          type: "submit",
          "input-class": "btn btn-primary btn-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(FormKitSubmitButtonContent, null, {
              default: _withCtx(() => [
                _createTextVNode("Load")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})